import { ASSET_QUESTIONS, VISIT_CONTACT_TYPE } from '@funnels/constants';
import { Question, RelatedPartyType } from '@funnels/types';

export function getPPSPropertyDisplayFields(questions: Question[], relatedPartyType?: RelatedPartyType) {
  const hasDateOfPurchase = questions.some((q: Question) => q === ASSET_QUESTIONS.DATE_OF_PURCHASE);
  const hasContactType = questions.some((q: Question) => q === ASSET_QUESTIONS.CONTACT_TYPE);
  const hasContactTitle = questions.some((q: Question) => q === ASSET_QUESTIONS.CONTACT_TITLE);
  const hasContactPhone = questions.some((q: Question) => q === ASSET_QUESTIONS.CONTACT_PHONE);
  const hasContactFirstName = questions.some((q: Question) => q === ASSET_QUESTIONS.CONTACT_FIRST_NAME);
  const hasContactLastName = questions.some((q: Question) => q === ASSET_QUESTIONS.CONTACT_LAST_NAME);
  const hasContactCompanyName =
    questions.some((q: Question) => q === ASSET_QUESTIONS.CONTACT_COMPANY_NAME) &&
    (relatedPartyType === VISIT_CONTACT_TYPE.RealEstateAgent || !relatedPartyType);

  return {
    hasDateOfPurchase,
    hasContactType,
    hasContactTitle,
    hasContactPhone,
    hasContactFirstName,
    hasContactLastName,
    hasContactCompanyName,
  };
}
